import { Checkbox, Container, FormControlLabel, Grid, makeStyles } from '@material-ui/core';
import { primaryGreen } from 'src/data/colors';

import { DefaultPointsProps } from './PointsInputs';

const useStyles = makeStyles(() => ({
  container: {
    padding: '10px 8px',
  },
  checkbox: {
    alignItems: 'center',
    display: 'flex',
    padding: 0,
    marginRight: 4,
    '&.Mui-checked': {
      color: primaryGreen,
    },
  },
}));

export const CheckboxList: React.FC<DefaultPointsProps> = ({
  onChange,
  point,
  value: incomingValue,
}) => {
  const classes = useStyles();

  const value = Array.isArray(incomingValue) ? point.scaledValue : incomingValue;
  const binaryLength = point.entry.dType === 'bitfield' ? 8 : 16;
  const values = value.toString(2).padStart(binaryLength, '0').split('').reverse();

  const meanings = Object.entries(point.entry.meanings || {});

  const onKeyChange = (key: number, isChecked: boolean) => {
    const newValues = [...values].map((value, index) => {
      if (index === key) {
        return isChecked ? '1' : '0';
      }
      return value;
    });
    onChange(point, parseInt(newValues.reverse().join(''), 2));
  };

  return (
    <Container className={classes.container}>
      {meanings.map(([key, value]) => (
        <Grid item key={key}>
          <FormControlLabel
            style={{ marginRight: 0 }}
            control={
              <Checkbox
                color="primary"
                className={classes.checkbox}
                checked={values[Number(key)] === '1'}
                onChange={(e) => onKeyChange(Number(key), e.target.checked)}
              />
            }
            label={value}
          />
        </Grid>
      ))}
    </Container>
  );
};
